import { useCouponStore } from "../../store/couponStore";
import Pagination from "../Pagination";
import { formatJustDate } from "../../utils/jalaliDate";

export default function CouponTable() {
  const coupons = useCouponStore((s) => s.coupons);
  const pagination = useCouponStore((s) => s.pagination);
  const isLoading = useCouponStore((s) => s.loading); // فرض بر وجود loading در store
  const setPage = useCouponStore((s) => s.setPage);
  const fetchCoupons = useCouponStore((s) => s.fetchCoupons);
  const openForm = useCouponStore((s) => s.openForm);

  // تابع تغییر صفحه که بلافاصله دیتای جدید را واکشی می‌کند
  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > pagination.totalPages) return;

    setPage(newPage);
    fetchCoupons(newPage);
  };


  const discountType = {
    PERCENT: "درصد",
    FIXED: "مبلغ ثابت",
  };

  return (
    <div className="bg-white shadow-md rounded-lg overflow-hidden">
      <div className="overflow-x-auto">
        <table className="min-w-full table-fixed">
          <thead className="bg-gray-100">
            <tr className="text-sm text-gray-700">
              <th className="w-48 px-3 py-3 text-right">کاربر</th>
              <th className="w-40 px-3 py-3 text-right">عنوان و کد</th>
              <th className="w-32 px-3 py-3 text-right">نوع تخفیف</th>
              <th className="w-28 px-3 py-3 text-right">مقدار</th>
              <th className="w-32 px-3 py-3 text-right">تعداد استفاده</th>
              <th className="w-32 px-3 py-3 text-right">حداقل سفارش</th>
              <th className="w-32 px-3 py-3 text-right">حداکثر تخفیف</th>
              <th className="w-36 px-3 py-3 text-right">تاریخ انقضا</th>
              <th className="w-24 px-3 py-3 text-right">وضعیت</th>
              <th className="w-24 px-3 py-3 text-center">عملیات</th>
            </tr>
          </thead>
          <tbody className="text-sm">
            {isLoading ? (
              <tr>
                <td colSpan={9} className="text-center py-10">
                  <div className="flex justify-center items-center gap-2">
                    <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-[#1E3A5F]"></div>
                    <span className="text-gray-600">در حال بارگذاری کوپن‌ها...</span>
                  </div>
                </td>
              </tr>
            ) : coupons.length === 0 ? (
              <tr>
                <td colSpan={9} className="text-center py-10 text-gray-500">
                  هیچ کوپنی یافت نشد.
                </td>
              </tr>
            ) : (
              coupons.map((c) => (
                  <tr key={c.id} className="border-b hover:bg-gray-50 transition">
                    {/* کاربر */}
                    <td className="px-3 py-3">
                      <div className="flex flex-col">
                      <span className="font-medium text-gray-800">
                        {c.user?.full_name || "همه کاربران"}
                      </span>
                        <span className="text-xs text-gray-500">
                        {c.user?.phone_number}
                      </span>
                      </div>
                    </td>

                    {/* عنوان و کد */}
                    <td className="px-3 py-3">
                      <div className="flex flex-col">
                        <span className="font-medium text-gray-700">{c.title}</span>
                        <span className="text-xs font-mono bg-gray-100 px-1 rounded self-start mt-1">
                        {c.code}
                      </span>
                      </div>
                    </td>

                    {/* نوع */}
                    <td className="px-3 py-3 text-gray-600">
                      {discountType[c.discount_type]}
                    </td>

                    {/* مقدار */}
                    <td className="px-3 py-3 font-bold text-gray-800">
                      {Number(c.discount_value).toLocaleString()}
                      {c.discount_type === "PERCENT" ? " %" : " تومان"}
                    </td>

                    {/* تعداد استفاده */}
                    <td className="px-3 py-3">
                    <span className="text-gray-600">
                      {c.usage_count} <span className="text-gray-400">از</span>{" "}
                      {c.usage_limit}
                    </span>
                    </td>

                    {/* حداقل سفارش */}
                    <td className="px-3 py-3 text-gray-600">
                      {Number(c.min_order_amount).toLocaleString()}
                    </td>
                    {/* حداکثر تخفیف */}
                    <td className="px-3 py-3 text-gray-600">
                      {Number(c.max_discount_amount).toLocaleString()}
                    </td>

                    {/* انقضا */}
                    <td className="px-3 py-3 text-gray-600 relative">
                      {c.is_expired && (
                          <span className="absolute top-1 right-1 text-[10px] text-red-600 font-medium">
                            منقضی شده
                          </span>)}
                      {c.expiration_date ? formatJustDate(c.expiration_date) : "---"}
                    </td>

                    {/* وضعیت */}
                    <td className="px-3 py-3">
                    <span
                        className={`text-xs px-2 py-1 rounded-full ${
                            c.is_active
                                ? "bg-green-100 text-green-700"
                                : "bg-red-100 text-red-700"
                        }`}
                    >
                      {c.is_active ? "فعال" : "غیرفعال"}
                    </span>
                    </td>

                    {/* عملیات */}
                    <td className="px-3 py-3 text-center">
                      <button
                          onClick={() => openForm(c)}
                          className="text-[#1E3A5F] hover:text-blue-800 font-medium transition-colors"
                      >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                        </svg>
                      </button>
                    </td>
                  </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* بخش صفحه‌بندی */}
      {!isLoading && coupons.length > 0 && (
          <Pagination
              page={pagination.page}
              setPage={handlePageChange}
              totalPages={pagination.totalPages}
        />
      )}
    </div>
  );
}
